export class SoftwareSlide {
  _id?: string;
  title: string = '';
  content: string = '';
  image: string = '';
  position: number = 0;
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/software-slide.model.ts